import { render } from "./TheKV.vue?vue&type=template&id=2ba966a8&scoped=true"
const script = {}

import "./TheKV.vue?vue&type=style&index=0&id=2ba966a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba966a8"]])

export default __exports__